import * as i0 from '@angular/core';
import * as i1 from './modal.module';
import * as i2 from '@angular/common';
import * as i3 from '../button/button.directive';
import * as i4 from '../icon/static-icon.component';
import * as i5 from '../placeholder/placeholder.component';
import * as i6 from './alert-modal.component';
import * as i7 from './modal-placeholder.component';
import * as i8 from './modal.component';
import * as i9 from './modal-header.component';
import * as i10 from './modal-footer.component';
import * as i11 from './overlay.component';
import * as i12 from '../button/button.module';
import * as i13 from '../icon/static-icon.module';
import * as i14 from '../i18n/i18n.module';
import * as i15 from '../placeholder/placeholder.module';
export const ModalModuleNgFactory:i0.NgModuleFactory<i1.ModalModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.Button = (<any>(null as any));
var _decl0_12:i4.StaticIcon = (<any>(null as any));
var _decl0_13:i5.Placeholder = (<any>(null as any));
var _decl0_14:i6.AlertModal = (<any>(null as any));
var _decl0_15:i7.ModalPlaceholder = (<any>(null as any));
var _decl0_16:i8.Modal = (<any>(null as any));
var _decl0_17:i9.ModalHeader = (<any>(null as any));
var _decl0_18:i10.ModalFooter = (<any>(null as any));
var _decl0_19:i11.Overlay = (<any>(null as any));
var _decl0_20:i2.AsyncPipe = (<any>(null as any));
var _decl0_21:i2.UpperCasePipe = (<any>(null as any));
var _decl0_22:i2.LowerCasePipe = (<any>(null as any));
var _decl0_23:i2.JsonPipe = (<any>(null as any));
var _decl0_24:i2.SlicePipe = (<any>(null as any));
var _decl0_25:i2.DecimalPipe = (<any>(null as any));
var _decl0_26:i2.PercentPipe = (<any>(null as any));
var _decl0_27:i2.TitleCasePipe = (<any>(null as any));
var _decl0_28:i2.CurrencyPipe = (<any>(null as any));
var _decl0_29:i2.DatePipe = (<any>(null as any));
var _decl0_30:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_31:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_32:i2.KeyValuePipe = (<any>(null as any));
var _decl0_33:i2.CommonModule = (<any>(null as any));
var _decl0_34:i12.ButtonModule = (<any>(null as any));
var _decl0_35:i13.StaticIconModule = (<any>(null as any));
var _decl0_36:i14.I18nModule = (<any>(null as any));
var _decl0_37:i15.PlaceholderModule = (<any>(null as any));
var _decl0_38:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_39:i0.ElementRef<any> = (<any>(null as any));
function _View_AlertModal_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_AlertModal_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_14.modalType;
  currVal_0;
  const currVal_1:any = _decl0_14.modalTitle;
  currVal_1;
  const currVal_2:any = _decl0_14.modalLabel;
  currVal_2;
  const currVal_3:any = _decl0_14.modalTitle;
  currVal_3;
  const currVal_4:any = _decl0_14.modalContent;
  currVal_4;
  const currVal_5:any = (_decl0_14.buttons.length > 0);
  currVal_5;
  const pd_6:any = ((<any>_decl0_14.closeModal()) !== false);
}
function _View_ModalPlaceholder_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_ModalPlaceholder_2_0():void {
  var _any:any = (null as any);
}
function _View_Modal_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_Modal_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_16.theme;
  currVal_0;
  const currVal_1:any = _decl0_16.modalState;
  currVal_1;
  const currVal_2:any = _decl0_16.modalLabel;
  currVal_2;
  const pd_3:any = ((<any>_decl0_16.overlaySelected.emit()) !== false);
}
function _View_ModalHeader_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_ModalHeader_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(1,'',_decl0_17.theme,' bx--modal-header');
  currVal_0;
  const currVal_1:any = _decl0_17.closeLabel;
  currVal_1;
  const currVal_2:any = _decl0_17.closeLabel;
  currVal_2;
  const currVal_3:any = _decl0_17.closeLabel;
  currVal_3;
  const currVal_4:any = _decl0_17.closeLabel;
  currVal_4;
  const pd_5:any = ((<any>_decl0_17.onClose()) !== false);
}
function _View_ModalFooter_Host_5_0():void {
  var _any:any = (null as any);
}
function _View_ModalFooter_5_0():void {
  var _any:any = (null as any);
}
function _View_Overlay_Host_6_0():void {
  var _any:any = (null as any);
}
function _View_Overlay_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'bx--modal bx--modal-tall is-visible';
  currVal_0;
  const currVal_1:any = (<any>{'bx--modal--danger':(_decl0_19.theme === 'danger')});
  currVal_1;
  const pd_2:any = ((<any>_decl0_19.overlayClick(_any)) !== false);
}
